import React, { useState, useEffect } from 'react';

import { Typography, Grid, Button } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import { motion, useAnimation } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

import playButton from '../assets/playAudio3.svg';
import pauseButton from '../assets/pauseAudio.svg';
import erikaPullQuote from '../assets/audio/pullQuote2Erika.wav';
import blueOrb from '../assets/pullQuote2Orb.svg';
import blueOrbM from '../assets/pullQuote2OrbM.svg';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    width: '100%',
    marginTop: '6.25rem',
    position: 'relative',
    // overflow: 'hidden',
    [theme.breakpoints.down('sm')]: {
      marginTop: '3.125rem'
    }
  },
  text: {
    width: '51%',
    textAlign: 'center',
    borderTop: '1px solid black',
    borderBottom: '1px solid black',
    [theme.breakpoints.down('sm')]: {
      width: '75%'
    }
  },
  pullQuote: {
    ...theme.extraFonts.pullQuote,
    paddingTop: '3.125rem',
    [theme.breakpoints.down('sm')]: {
      ...theme.typography.body2
    }
  },
  quotationMark: {
    color: theme.palette.common.blue,
    fontSize: '60px',
    [theme.breakpoints.down('sm')]: {
      ...theme.typography.body2
    }
  },
  name: {
    fontFamily: 'proximaNovaB',
    margin: '2.1rem 0',
    [theme.breakpoints.down('sm')]: {
      margin: '1rem 0'
    }
  },
  audioButton: {
    marginBottom: '3.125rem',
    '&:hover': {
      transform: 'scale(1.1,1.1)'
    }
  },
  button1: {
    padding: 0,
    '&:hover': {
      backgroundColor: 'transparent',
      boxShadow: 'none'
    }
  },
  blueOrb: {
    position: 'absolute',
    top: '-170px',
    left: '0px',
    zIndex: -1,
    [theme.breakpoints.down('sm')]: {
      top: '-300px'
    }
  }
}));

const erikaPullQuoteAudio = new Audio(erikaPullQuote);

const PullQuote1 = () => {
  const classes = useStyles();
  const theme = useTheme();
  const matchesSM = useMediaQuery(theme.breakpoints.down('sm'));
  const [isPlaying, setIsPlaying] = useState(false);

  const { ref, inView } = useInView({ threshold: 0.5 });
  const animation = useAnimation();

  useEffect(() => {
    if (inView) {
      animation.start({
        opacity: 1,
        transition: {
          type: 'spring',
          duration: 3
        }
      });
    }
    if (!inView) {
      animation.start({ opacity: 0 });
    }
  }, [inView, animation]);

  const audioClickHandler = (name) => {
    if (isPlaying) {
      erikaPullQuoteAudio.pause();
      setIsPlaying(false);
    } else {
      erikaPullQuoteAudio.play();
      setIsPlaying(true);
    }
  };

  return (
    <Grid container justifyContent="center" className={classes.wrapper}>
      <motion.img
        animate={animation}
        ref={ref}
        src={matchesSM ? blueOrbM : blueOrb}
        alt="blue gradient circle"
        className={classes.blueOrb}
      />
      <Grid item className={classes.text}>
        <Typography className={classes.pullQuote}>
          <span className={classes.quotationMark}>“</span>Initiating these conversations with a
          provider ... is a way of taking back power
        </Typography>
        <Typography variant="body2" className={classes.name}>
          Erika Stallings
        </Typography>
        <Button
          disableFocusRipple
          disableRipple
          onClick={() => {
            audioClickHandler();
          }}
          className={classes.button1}
        >
          <img
            src={isPlaying ? pauseButton : playButton}
            alt="audio controller"
            className={classes.audioButton}
            style={{ height: '47px' }}
          />
        </Button>
      </Grid>
    </Grid>
  );
};

export default PullQuote1;
